module.exports = __webpack_public_path__ + "static/media/img_title1@2x.a20aa110.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_title1@2x.png
// module id = 776
// module chunks = 0